import { Mail, Phone, Linkedin, Github, MapPin } from 'lucide-react'
import { getContactInfo } from '../utils/cvParser'

const Hero = () => {
  const contact = getContactInfo()
  
  const getLinkedInUrl = (username) => `https://linkedin.com/in/${username}`
  const getGitHubUrl = (username) => `https://github.com/${username}`
  
  const linkedIn = contact.socialNetworks.find(n => n.network === 'LinkedIn')
  const github = contact.socialNetworks.find(n => n.network === 'GitHub')

  return (
    <section className="bg-gradient-to-br from-navy-800 via-navy-700 to-primary-900 text-white">
      <div className="section-container min-h-[80vh] flex items-center">
        <div className="w-full grid md:grid-cols-2 gap-12 items-center">
          <div>
            <div className="mb-8">
              <h1 className="text-5xl md:text-6xl font-bold mb-4 animate-fade-in">
                {contact.name}
              </h1>
              <h2 className="text-2xl md:text-3xl text-navy-200 mb-6">
                Senior Data Engineer Consultant
              </h2>
              <p className="text-xl text-gray-200 max-w-3xl leading-relaxed">
                Transforming raw data into world-class predictive models. 
                Expert in automating data extraction, ML/AI implementations, 
                and building scalable data platforms that drive business value.
              </p>
            </div>
          
            <div className="flex flex-wrap gap-6 mb-8">
              <a 
              href={`mailto:${contact.email}`}
              className="flex items-center gap-2 bg-white/10 hover:bg-white/20 backdrop-blur-sm px-5 py-3 rounded-lg transition-all duration-300 hover:scale-105"
              >
                <Mail size={20} />
                <span>{contact.email}</span>
              </a>
              
              {contact.phone && (
                  <a 
                  href={`tel:${contact.phone}`}
                  className="flex items-center gap-2 bg-white/10 hover:bg-white/20 backdrop-blur-sm px-5 py-3 rounded-lg transition-all duration-300 hover:scale-105"
                >
                  <Phone size={20} />
                  <span>{contact.phone}</span>
                </a>
              )}
            </div>
            
            <div className="flex gap-4">
              {linkedIn && (
                <a 
                  href={getLinkedInUrl(linkedIn.username)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 bg-navy-600 hover:bg-navy-700 px-6 py-3 rounded-lg font-semibold transition-all duration-300 hover:scale-105 shadow-lg"
                >
                  <Linkedin size={20} />
                  <span>LinkedIn</span>
                </a>
              )}
              
              {github && (
                  <a 
                  href={getGitHubUrl(github.username)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 bg-primary-800 hover:bg-primary-700 px-6 py-3 rounded-lg font-semibold transition-all duration-300 hover:scale-105 shadow-lg"
                >
                  <Github size={20} />
                  <span>GitHub</span>
                </a>
              )}
            </div>
          </div>
          
          <div className="flex justify-center md:justify-end">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-br from-navy-500 to-primary-600 rounded-2xl transform rotate-3"></div>
              <img 
                src="/profile-photo.jpg" 
                alt="Luis Felipe Cubero Vargas"
                className="relative rounded-2xl shadow-2xl w-full max-w-md object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Hero
